import { render, staticRenderFns } from "./businessMessage.vue?vue&type=template&id=48177c90&scoped=true"
import script from "./businessMessage.vue?vue&type=script&lang=js"
export * from "./businessMessage.vue?vue&type=script&lang=js"
import style0 from "./businessMessage.vue?vue&type=style&index=0&id=48177c90&prod&lang=scss&scoped=true"
import style1 from "./businessMessage.vue?vue&type=style&index=1&id=48177c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48177c90",
  null
  
)

export default component.exports